import { NoteAdd } from '@mui/icons-material';
import { IconButton, TextField, Tooltip } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import React, { useState } from 'react';
import Api from '../../Api';
import { IMaterialNoteDialogProps } from '../../interfaces';



export const MaterialNoteDialog: React.SFC<IMaterialNoteDialogProps> = ({
    materialId,
    onNoteAdded,
    ...props
}: IMaterialNoteDialogProps) => {

    const onAdd = async () => {
        if (materialId) {
            setLoading(true);
            Api.Materials.Notes.add(materialId, note).then((data: any) => {
                onNoteAdded(data as string);
                setOpen(false);
                setLoading(false);
                setNote("");
            });
        }
    }

    const onCancel = () => {
        setOpen(false);
    }

    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [note, setNote] = useState("");

    return (
        <span>
            <Tooltip title="Add Notes">
                <IconButton onClick={() => setOpen(true)}>
                    <NoteAdd color="primary" />
                </IconButton>
            </Tooltip>
            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                fullWidth
                maxWidth="sm"
            >
                <form
                    onSubmit={(e) => { }}
                    onInvalid={() => setErrorMessage("please check that all required fields have been populated")}
                >
                    <DialogContent>
                        <TextField
                            label="New Note"
                            multiline
                            fullWidth
                            rows={4}
                            value={note}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                setNote(e.currentTarget.value)
                            }
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={onCancel} color="warning">Cancel</Button>
                        <Button
                            disabled={note.length === 0 || loading}
                            onClick={onAdd}
                        >
                            Add Note
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        </span>
    );
}